(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/service-wager/assets/services/post-racing-wager.js') >= 0) return;  svs.modules.push('/components/payment/service-wager/assets/services/post-racing-wager.js');

'use strict';

const {
  RequestPaymentError,
  RequestRacingPaymentError
} = svs.components.payment.common.error;
const {
  jupiterFetch
} = svs.core;

const postRacingWager = async wager => {
  try {
    const response = await jupiterFetch.fetch('/racing/10/wager/wagers', {
      method: 'POST',
      body: JSON.stringify(wager),
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json'
      }
    });
    const data = await response.json();
    if (!response.ok) {
      var _data$error, _data$error2;
      throw new RequestRacingPaymentError({
        clientCode: RequestPaymentError.ClientErrorCodes.PAYMENT_REQUEST_FAILURE,
        code: (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.code,
        extraData: {
          message: (_data$error2 = data.error) === null || _data$error2 === void 0 ? void 0 : _data$error2.message
        }
      });
    }
    return data;
  } catch (error) {
    switch (error === null || error === void 0 ? void 0 : error.name) {
      case 'TypeError':
        throw new RequestRacingPaymentError({
          clientCode: RequestPaymentError.ClientErrorCodes.PAYMENT_FETCH_FAILURE,
          code: error === null || error === void 0 ? void 0 : error.code,
          extraData: {
            message: error === null || error === void 0 ? void 0 : error.message
          }
        });
      case 'RequestRacingPaymentError':
      default:
        throw error;
    }
  }
};
setGlobal('svs.components.payment.serviceWager.services.postRacingWager', postRacingWager);

 })(window);